import React, { useState } from "react";
import AuthContext from "./auth-context";
import Auth from "./auth";
import moment from "moment";
import { VERIF_TOKEN } from "../utils/constants";

const AuthProvider: any = (params: any): JSX.Element => {
  let userHasValidToken = () => {
    console.log(`AUTHPROVIDER: checking token validity`, authToken);
    if (
      (authToken === null ||
        typeof authToken === "undefined" ||
        authToken === "") &&
      sessionStorage.getItem(VERIF_TOKEN) !== null
    ) {
      console.log(
        `AUTHPROVIDER: Setting token from session storage since state token doesn't exist`
      );
      setAuthToken(sessionStorage.getItem(VERIF_TOKEN) ?? "");
      return true;
    }

    if (
      authToken !== null &&
      typeof authToken !== "undefined" &&
      authToken !== ""
    ) {
      return true;
    }

    return false;
  };

  /*
        var decodedToken=jwt.decode(token, {complete: true});
var dateNow = new Date();

if(decodedToken.exp < dateNow.getTime())
    isExpired = true;
        return (authToken !== null && typeof authToken !== 'undefined' && authToken !== '');
        */
  const [auth] = useState<Auth>(new Auth());
  const [authToken, setAuthToken] = useState<string>("");

  let setToken = (token: string) => {
    console.log(`AUTHPROVIDER: setting token`, token);
    sessionStorage.setItem(VERIF_TOKEN, token);
    setAuthToken(token);
    sessionTimeout();
  };
  let getToken = (): string => {
    console.log(`AUTHPROVIDER: getting token`, authToken);
    return authToken;
  };
  let logout = () => {
    console.log(`AUTHPROVIDER: logging out`, authToken);
    sessionStorage.removeItem(VERIF_TOKEN);
    setAuthToken("");
    console.log(`AUTHPROVIDER: logged out`, authToken);
  };

  const sessionTimeout = () => {
    const timeout = process.env.REACT_APP_SESSION_KICKOUT ?? "1200000";
    setTimeout(function () {
      console.log("timeout happened");
      logout();
    }, parseInt(timeout));
  };

  return (
    <AuthContext.Provider
      value={{
        authToken: getToken,
        setAuthToken: setToken,
        userHasValidToken: userHasValidToken,
        logout: (): void => {
          logout();
        },
      }}
    >
      {params.children}
    </AuthContext.Provider>
  );
};
export default AuthProvider;
